var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.9,14.4L16.4,0l-3.9,14.4,3.3.9-10.1,12.8,3.4-12.8-3.3-.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.9,6.3c-1,0-1.5.5-1.5,1.4s.1.8.4,1c.2.2.6.4,1.1.4s.8-.1,1.1-.4c.2-.3.4-.6.4-1,0-.9-.5-1.4-1.4-1.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.9,11.2h-2.1v12h2.1v-12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.6,6.4h-2.1v16.8h2.1v-4.7l1-1,4.5,5.6h2.6l-5.5-6.9,4.8-5.1h-2.6l-4.8,5.1V6.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,11.2v6c0,.5,0,1.1.1,1.6.1.5.3,1,.5,1.4.2.4.5.7.9,1,.4.2.8.3,1.3.3,1.2,0,2.1-.4,2.5-1.3.5-.9.7-2.1.7-3.8v-5.2h2.1v12h-2.1v-1.5c-.3.4-.6.7-.9,1-.7.5-1.6.8-2.7.8s-1.6-.2-2.2-.5c-.6-.3-1.1-.8-1.4-1.3-.4-.6-.6-1.2-.8-2-.2-.8-.2-1.6-.2-2.4h0v-6h2.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.4,6.4v16.8h2.3v-4.9l3-3.6,4.9,8.5h2.6l-6-10.2,5.7-6.6h-3l-7.3,8.7V6.4h-2.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.7,5.2h1.8l-1.6,2.2h-.2c-2.9,0-5.2,2.3-5.2,5.2v4.7c0,1.8.9,3.4,2.3,4.3l-.6,2.2c-2.3-1.2-3.9-3.7-3.9-6.5v-4.7c0-4.1,3.3-7.4,7.4-7.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.6,5.9l-.6,2.1c1.5.9,2.6,2.6,2.6,4.5v4.7c0,2.9-2.3,5.2-5.2,5.2h-1l-1.6,2.2h2.6c4.1,0,7.4-3.3,7.4-7.4v-4.7c0-2.9-1.7-5.4-4.1-6.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrLogo);
export default __webpack_public_path__ + "static/media/qrLogo.4d6138616145abb766df6791bf19281b.svg";
export { ForwardRef as ReactComponent };